import React from 'react';
import { useRounds } from '../../../Data/Rounds';
import Select from './Select';

const Round = (props) => {
    const {rounds} = useRounds();

    if (!rounds) {
        return <Select key="loading" label={props.label} options={[{value: '', label: 'Loading'}]} disabled />
    }

    const options = [{value: 'no-round', label: props.noRoundSelectedLabel ?? 'None'}, ...rounds.map(r => ({value: r.id, label: r.name}))];

    return <>
        <Select {...{options, ...props}} />
    </>
}

export default Round;
